// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tZN4","icon":"styles_icon__2zCvw"};